export const AP_HIDDEN_FEATURES = "ap-hidden-features";
export const AP_DEFAULT_TICKED_CHECKBOXES = "ap-replication-default-checkboxes";

export type FeatureValue = string | number | boolean | object | null | undefined;
export type FeatureType = "string" | "number" | "boolean" | "json";

export interface FeatureItem {
  key: string;
  originalValue: FeatureValue;
  currentValue: FeatureValue;
  type: FeatureType;
  hasChanged: boolean;
  isHidden?: boolean;
}

export const determineFeatureType = (value: FeatureValue): FeatureType => {
  if (typeof value === "boolean") return "boolean";
  if (typeof value === "number") return "number";
  if (typeof value === "object" && value !== null) return "json";
  if (typeof value === "string") {
    // Try to parse as number
    const numValue = Number(value);
    if (!isNaN(numValue) && value.toString() === numValue.toString()) {
      return "number";
    }
    // Check for boolean strings
    if (value.toLowerCase() === "true" || value.toLowerCase() === "false") {
      return "boolean";
    }
    // check for json strings
    try {
      JSON.parse(value);
      return "json";
    } catch {
      return "string";
    }
  }
  return "string";
};

export const formatValueForInput = (value: FeatureValue, type: FeatureType): string => {
  if (value === null || value === undefined) {
    return "";
  }
  if (type === "boolean") {
    if (typeof value === "boolean") {
      return value.toString();
    }
    if (typeof value === "string" && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) {
      return value.toLowerCase();
    }
    return "undefined";
  }
  if (type === "json") {
    try {
      if (typeof value === "string") {
        try {
          const parsed = JSON.parse(value);
          return JSON.stringify(parsed, null, 2);
        } catch {
          return value;
        }
      }
      return JSON.stringify(value, null, 2);
    } catch {
      return "undefined";
    }
  }
  return String(value);
};

export const parseValueFromInput = (inputValue: string, type: FeatureType): FeatureValue => {
  if (inputValue === "" || inputValue === "undefined") {
    return undefined;
  }
  let num: number;

  switch (type) {
    case "boolean":
      if (inputValue === "true") return true;
      if (inputValue === "false") return false;
      return undefined;
    case "number":
      num = Number(inputValue);
      return isNaN(num) ? inputValue : num;
    case "json":
    case "string":
    default:
      return inputValue;
  }
};

export const isNumberValid = (value: string): boolean => {
  if (value === "" || value === "undefined") return true;
  return !isNaN(Number(value));
};

export const isJsonValid = (value: string): boolean => {
  if (value === "" || value === "undefined") return true;
  try {
    JSON.parse(value);
    return true;
  } catch {
    return false;
  }
};
